<template>
  <div>
    <b-overlay :show="isLoading" rounded="sm">
      <b-container fluid>
        <b-navbar toggleable="lg" type="dark" variant="light">
          <b-navbar-brand href="#" class="text-dark">
            <strong>Departments</strong>
          </b-navbar-brand>

          <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

          <b-collapse id="nav-collapse" is-nav>
            <!-- Right aligned nav items -->
            <b-navbar-nav class="ml-auto">
              <b-nav-form>
                <b-button
                  size="sm"
                  variant="outline-primary"
                  @click="showModal = !showModal"
                  class="mx-2"
                >
                  <font-awesome-icon icon="plus" />
                </b-button>

                <b-button size="sm" class="mr-3" variant="outline-info" @click="reloadTable">
                  <font-awesome-icon icon="sync" />
                </b-button>
                <b-form-group
                  label-cols-sm="3"
                  label-align-sm="right"
                  label-size="sm"
                  label-for="filterInput"
                >
                  <b-input-group size="sm">
                    <b-form-input
                      v-model="filter"
                      type="search"
                      id="filterInput"
                      placeholder="Type to Search"
                    ></b-form-input>
                    <b-input-group-append>
                      <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-nav-form>
            </b-navbar-nav>
          </b-collapse>
        </b-navbar>

        <b-table
          class="mx-1"
          bordered
          sticky-header="calc(100vh - 200px)"
          ref="table"
          id="my-table"
          :busy.sync="isLoading"
          :items="getDepartmentsTableData"
          :fields="tableFields"
          :filter="filter"
          :per-page="perPage"
          :current-page="currentPage"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          responsive="sm"
        >
          <template v-slot:cell(created_at)="data">{{ age(data.item.created_at) }}</template>
          <template v-slot:cell(actions)="data">
            <div class="text-nowrap">
              <b-button
                size="sm"
                class="mr-2"
                type="button"
                variant="outline-info"
                @click="onEdit(data.item)"
              >
                <font-awesome-icon v-b-tooltip.hover title="Edit Field" icon="edit" />
              </b-button>
              <b-button size="sm" type="button" variant="outline-danger" @click="onDelete(data.item)">
                <font-awesome-icon v-b-tooltip.hover title="Delete Field" icon="trash" />
              </b-button>
            </div>
          </template>
        </b-table>
        <b-row>
          <b-col cols="2">
            <b-form-select size="sm" v-model="perPage" id="perPageSelect" :options="pageOptions"></b-form-select>
          </b-col>
          <b-col>
            <b-pagination
              class="float-right"
              v-model="currentPage"
              :total-rows="rows"
              :per-page="perPage"
              first-text="First"
              prev-text="Prev"
              next-text="Next"
              last-text="Last"
              aria-controls="my-table"
            ></b-pagination>
          </b-col>
        </b-row>
      </b-container>
    </b-overlay>

    <b-modal
      no-close-on-backdrop
      no-close-on-esc
      hide-header-close
      size="lg"
      :title="editDepartment ? 'Update Department' : 'Create New Department'"
      v-model="showModal"
    >
      <div>
        <div v-if="!submiting && !responseSuccess">
          <b-form-group>
            <label>
              Department :
              <span class="required-span">*</span>
            </label>
            <b-form-input
              v-model="$v.form.department.$model"
              :state="$v.form.department.$dirty ? !$v.form.department.$error : null"
              placeholder="Enter Department"
            ></b-form-input>
          </b-form-group>
        </div>
        <div v-else-if="submiting && !responseSuccess">
          <p>{{editDepartment ? 'Your Department is being Updating......' : 'Your Department is being Creating......'}}</p>
          <b-spinner type="grow" label="Loading..."></b-spinner>
        </div>
        <div v-else>
          <p class="my-2 text-center">
            {{ editDepartment ? 'Your Department has been updated successfully.' : 'Your Department has been added successfully.' }}
            <br />
          </p>
        </div>
      </div>
      <template v-slot:modal-footer>
        <b-button v-if="!submiting" variant="outline-danger" @click="resetModal">Close</b-button>
        <b-button
          v-if="!submiting && !responseSuccess"
          variant="outline-success"
          @click="checkValidation()"
        >{{ editDepartment ? 'Update' : 'Save' }}</b-button>
      </template>
    </b-modal>
    <b-overlay :show="showDeleteDepartment" no-wrap>
      <template v-slot:overlay>
        <div v-if="processing" class="text-center p-4 bg-primary text-light rounded">
          <font-awesome-icon size="lg" icon="cloud-upload-alt" />
          <div class="mb-3">Deleting...</div>
          <b-progress
            min="1"
            max="20"
            :value="counter"
            variant="success"
            height="3px"
            class="mx-n4 rounded-0"
          ></b-progress>
        </div>
        <div
          v-else
          ref="dialog"
          tabindex="-1"
          role="dialog"
          aria-modal="false"
          aria-labelledby="form-confirm-label"
          class="text-center p-3"
        >
          <p>
            <strong id="form-confirm-label">Are you sure?</strong>
          </p>
          <div class="d-flex">
            <b-button variant="outline-success" class="mr-3" @click="resetDeleteModal">Cancel</b-button>
            <b-button variant="outline-danger" @click="deleteDepartmentCall">Yes</b-button>
          </div>
        </div>
      </template>
    </b-overlay>
  </div>
</template>
<script>
import { HTTP } from "../../utils/HTTP";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import moment from "moment";
import "moment/locale/es";
export default {
  name: "PriSettingsDepartmentsPage",
  mixins: [validationMixin],
  data() {
    return {
      editDepartment: false,
      submiting: false,
      responseSuccess: false,
      showModal: false,
      tableFields: [
        { key: "created_at", label: "Age", sortable: true },
        { key: "department", label: "Department", sortable: true },
        { key: "actions", label: "Actions", sortable: true }
      ],
      filter: null,
      perPage: 10,
      totalRows: 0,
      currentPage: 1,
      sortBy: "id",
      sortDesc: true,
      pageOptions: [5, 10, 25, 50, 75, 100],
      isLoading: false,
      form: {
        department: null
      },
      departmentId: null,
      showDeleteDepartment: false,
      processing: false,
      counter: 1,
      interval: null
    };
  },
  validations: {
    form: {
      department: { required }
    }
  },
  computed: {
    rows() {
      return this.totalRows;
    }
  },
  beforeDestroy() {
    this.clearInterval();
  },
  methods: {
    clearInterval() {
      if (this.interval) {
        clearInterval(this.interval);
        this.interval = null;
      }
    },
    reloadTable() {
      this.$root.$emit("bv::refresh::table", "my-table");
    },
    async getDepartmentsTableData() {
      let formData = {
        filter: this.filter,
        sort: this.sortBy + "|" + (this.sortDesc == true ? "desc" : "asc"),
        per_page: this.perPage,
        page: this.currentPage
      };

      let token = "Bearer " + localStorage.getItem("accessToken");
      this.isLoading = true;
      let result = HTTP("post", "v1/get-departments-data", formData, {
        Authorization: token
      });

      return result
        .then(response => {
          const items = response.data.data;
          this.isLoading = false;
          this.totalRows = response.data.total;
          return items;
        })
        .catch(error => {
          this.isLoading = false;
          return [error];
        });
    },
    age(value) {
      moment.locale("en");
      return moment.utc(value).fromNow();
    },
    onEdit(value) {
      this.departmentId = value.id;
      this.editDepartment = true;
      this.showModal = true;
      this.form = {
        department: value.department
      };
    },
    checkValidation() {
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        return;
      } else if (this.editDepartment) {
        this.updateDepartment().then(this.reloadTable);
      } else {
        this.saveDepartment().then(this.reloadTable);
      }
    },
    async saveDepartment() {
      let formData = {
        department: this.form.department
      };
      try {
        let token = "Bearer " + localStorage.getItem("accessToken");
        this.submiting = true;
        this.isLoading = true;
        await HTTP("post", "v1/create-department", formData, {
          Authorization: token
        });
        this.submiting = false;
        this.isLoading = false;
        this.responseSuccess = true;
      } catch (err) {
        return [err];
      }
    },
    async updateDepartment() {
      let formData = {
        department_id: this.departmentId,
        department: this.form.department
      };
      try {
        let token = "Bearer " + localStorage.getItem("accessToken");
        this.submiting = true;
        this.isLoading = true;
        await HTTP("post", "v1/update-department", formData, {
          Authorization: token
        });
        this.submiting = false;
        this.isLoading = false;
        this.responseSuccess = true;
      } catch (err) {
        return [err];
      }
    },
    resetForm() {
      this.form = {
        department: null
      };
    },
    resetModal() {
      this.resetForm();
      this.submiting = false;
      this.responseSuccess = false;
      this.editDepartment = false;
      this.showModal = false;
      this.$v.$reset();
    },
    onDelete(data) {
      this.departmentId = data.id;
      this.processing = false;
      this.showDeleteDepartment = true;
    },
    deleteDepartmentCall() {
      this.counter = 1;
      this.processing = true;
      this.deleteDepartment().then(this.reloadTable);
      this.clearInterval();
      this.interval = setInterval(() => {
        if (this.counter < 20) {
          this.counter = this.counter + 1;
        } else {
          this.clearInterval();
          this.$nextTick(() => {
            this.showDeleteDepartment = this.processing = false;
          });
        }
      }, 350);
    },
    async deleteDepartment() {
      try {
        let token = "Bearer " + localStorage.getItem("accessToken");
        await HTTP(
          "get",
          "v1/delete-department/" + this.departmentId,
          null,
          {
            Authorization: token
          }
        );
        this.departmentId = null;
      } catch (error) {
        this.isLoading = false;
      }
    },
    resetDeleteModal() {
      this.showDeleteDepartment = false;
    }
  }
};
</script>